import { useCallback } from "react";

import { formatDataSourceCondition } from "../../modules/Dashboard/utils";
import { useWidgetConfiguration } from "../../modules/Dashboard/hooks/useWidgetConfiguration";
import { useProjectDataSourceFilters } from "../../modules/FeatureCard/hooks/useProjectDataSourceFilters";
import { useEwktGeometry } from "../../modules/FeatureSelector/hooks/useEwktGeometry";
import { FilterConditionOperation } from "../../components/LayerFilter/types";
import { WidgetType } from "../../modules/FeatureCard/types";

export const useDataSourceCondition = () => {
  const [filters] = useProjectDataSourceFilters();
  const config = useWidgetConfiguration(WidgetType.Dashboard);
  const ewktGeometry = useEwktGeometry();

  return useCallback(
    (layerName: string) => {
      const layer = config?.currentConfig?.layers?.find(({ name }) => name === layerName);

      if (!layer) {
        return [];
      }

      return formatDataSourceCondition({
        condition: layer.condition,
        configFilters: config.currentConfig?.filters,
        filters,
        geometry: ewktGeometry,
      }).split(` ${FilterConditionOperation.AND} `);
    },
    [config, filters, ewktGeometry],
  );
};
